module.exports = __webpack_public_path__ + "img/triller.dc88274e.png";